import Axios from 'axios';
import tokenService from './token.service';
import { generateXHash } from '../utils/encrypt';

export const sendApiRequest = (config) => {
  const axios = Axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: {
      Authorization: {
        toString() {
          return `Bearer ${tokenService.getLocalAccessToken()}`;
        },
      },
      'Content-Type': 'application/json',
    },
  });
  const axios2 = Axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT2,
    headers: {
      Authorization: {
        toString() {
          return `Bearer ${tokenService.getLocalAccessToken()}`;
        },
      },
      'Content-Type': 'application/json',
    },
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.message.toLowerCase().includes('network')) {
        return axios2(config);
      }
      return Promise.reject(error);
    }
  );

  return axios(config);
};

export const cdnInstance = Axios.create({
  baseURL: process.env.REACT_APP_CDN_ENDPOINT,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getSecurityHeaders = async () => {
  try {
    const tokenInfo = tokenService.parseAccessToken();
    console.log(tokenInfo);
    const mac = tokenInfo.aud;
    const password = tokenInfo.role;
    const ts = new Date().getTime();

    return {
      // 'X-Gc-Token': await generateXHash(`${mac}${ts}${ts * 2}`),
      'x-hash': await generateXHash(`${mac}___${password}`),
      'x-hash-2': await generateXHash(`${mac}___${password}__${ts}`),
      'x-token': await generateXHash(`${mac}${ts}`),
      'x-token-2': await generateXHash(mac),
      // 'x-token-3': encryptToken(mac),
    };
  } catch (e) {
    return {};
  }
};

cdnInstance.interceptors.request.use(
  (config) => {
    const token = tokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token; // for Spring Boot back-end
      // config.headers["x-access-token"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// instance.interceptors.response.use(
//   (res) => {
//     return res;
//   },
//   async (err) => {
//     const originalConfig = err.config;
//     console.log('origin.config.url', originalConfig.url);
//     if (originalConfig.url !== '/admin/login' && err.response) {
//       // Access Token was expired
//       if (err.response.status === 401 && !originalConfig._retry) {
//         originalConfig._retry = true;

//         try {
//           const refreshToken = tokenService.getLocalRefreshToken();
//           if (!refreshToken) throw new Error('Please login again!');
//           const rs = await instance.post('/auth/refreshtoken', {
//             refreshToken: tokenService.getLocalRefreshToken(),
//           });

//           const { accessToken } = rs.data;
//           tokenService.setLocalAccessToken(accessToken);

//           return instance(originalConfig);
//         } catch (_error) {
//           return Promise.reject(_error);
//         }
//       }
//     }

//     return Promise.reject(err);
//   }
// );
